import { getImageBannerTemplate, getVueImageBannerTemplate } from "../../shortcodes/templates";

let imageBanner = null;

const visualizeImageBanner = content => {
  imageBanner = content.querySelectorAll('[data-wrapper-id="image-banner"]');
  if (imageBanner.length > 0) {
    imageBanner.forEach(item => {
      item.innerHTML = getImageBannerTemplate();
    });
  }
};

const serializeImageBanner = content => {
  imageBanner = content.querySelectorAll('[data-wrapper-id="image-banner"]');
  if (imageBanner.length > 0) {
    imageBanner.forEach(item => {
      const imageBannerData = item.getAttribute("data-image-banner-data");
      item.innerHTML = getVueImageBannerTemplate(imageBannerData);
    });
  }
};

export { visualizeImageBanner, serializeImageBanner };
